const API = `${process.env.REACT_APP_BACKEND_URL}/api/analytics`;
const ATTR_KEY = "hvm-attribution";

export const attribution = () => {
  let a = null;
  try {
    a = JSON.parse(sessionStorage.getItem(ATTR_KEY) || "null");
  } catch {
    a = null;
  }
  if (a) return a;
  const q = new URLSearchParams(window.location.search);
  a = {
    referrer: document.referrer || "",
    utm_source: q.get("utm_source") || "",
    utm_medium: q.get("utm_medium") || "",
    utm_campaign: q.get("utm_campaign") || "",
  };
  try {
    sessionStorage.setItem(ATTR_KEY, JSON.stringify(a));
  } catch {
    /* storage unavailable — attribution is best-effort */
  }
  return a;
};

const send = (body) => {
  if (window.location.pathname.startsWith("/analytics")) return;
  fetch(`${API}/hit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...attribution(), ...body }),
    keepalive: true,
  }).catch(() => {});
};

export const trackPageview = (path) => send({ path, event: "pageview" });
export const track = (event, meta) => send({ path: window.location.pathname, event, meta });
